import * as yup from "yup";

export const userMasterSchema = yup.object({
    firstName: yup.string().required("First Name is required."),
    email: yup.string().required("Email is required.").email("Invalid Email format"),
    phone: yup.string().required("Phone is required.").min(10, "Phone number must be atleast 10 digits"),
    username: yup.string().required("Username is required."),
    password: yup.string().required("Password is required."),
})
